<template>
  <div class="profile-dropdown flex-center">
    <span class="profile-dropdown__avatar-container">
      <slot />
    </span>
    <vuestic-dropdown v-model="isShown" position="bottom">
      <div
        v-for="option in options"
        :key="option.name"
        class="dropdown-item plain-link-item"
      >
        <span class="carro pointer" @click="$router.push(option.redirectTo)">{{
          option.name
        }}</span>
      </div>
      <div class="dropdown-item plain-link-item">
        <logout />
      </div>
    </vuestic-dropdown>
  </div>
</template>

<script>
import Logout from "../../../../auth/logout/Logout";

export default {
  name: "profile-section",
  components: { Logout },
  data() {
    return {
      isShown: false,
    };
  },
  props: {
    options: {
      type: Array,
      default: () => [
        {
          name: "Ver Carro",
          redirectTo: "/ventas/carro-ventas",
        },
      ],
    },
  },
};
</script>

<style lang="scss">
@import "../../../../../vuestic-theme/vuestic-sass/resources/resources";

.profile-dropdown {
  cursor: pointer;

  &__avatar-container {
    display: inline-block;
    width: 50px;
    height: 50px;
    background-color: white;
    border-radius: 50%;
    border: 2px solid $lighter-gray;
    overflow: hidden;

    img {
      height: 100%;
      width: 100%;
    }
  }
}
.carro {
  text-align: center;
  margin-left: 14.5px;
  color: #8bff76;
  font-weight: bold;
}
</style>
